module.exports = __webpack_public_path__ + "static/img/3634_phase_function_Paper_PointsHejduk_Prediction.3330c9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3634_phase_function_Paper_PointsHejduk_Prediction.png
// module id = z7Ca
// module chunks = 0